import {
  regex
} from 'vuelidate/lib/validators/common';
import {
  emailRegex
} from '@/constants';

export default regex('emailAddress', emailRegex);